module.exports = __webpack_public_path__ + "img/handwritten-postcard@1x.b1291d15.jpg";